import { getContactSchema } from "./contactSchema";
import { api } from "../../common/utils/api";

export const initContactForm = () => {
  const container = document.getElementById("contact-form-container");
  const form = container?.querySelector<HTMLFormElement>(".cf-form");
  const translations =
    (window as any).commonVariables?.translations?.contactForm || {};

  if (!form || !container) return;

  const fieldset = form.querySelector("fieldset");
  const submitBtn = form.querySelector<HTMLButtonElement>(".cf-form__submit");
  const errorAlert = form.querySelector<HTMLElement>(".cf-form__alert--error");
  const originalBtnText = submitBtn?.innerText || "";

  const clearErrors = () => {
    form
      .querySelectorAll(".cf-field__input")
      .forEach((el) => el.classList.remove("has-error"));
    form
      .querySelectorAll(".cf-field__error")
      .forEach((el) => (el.textContent = ""));
    if (errorAlert) {
      errorAlert.style.display = "none";
      errorAlert.innerHTML = "";
    }
  };

  const setFieldError = (fieldName: string, message: string) => {
    const input = form.querySelector(`[name="${fieldName}"]`);
    const errorDiv = input
      ?.closest(".cf-field")
      ?.querySelector(".cf-field__error");
    if (input && errorDiv) {
      input.classList.add("has-error");
      errorDiv.textContent = message;
    }
  };

  // Helper to generate success HTML using Vendor/Bootstrap classes
  const renderSuccessState = () => `
    <div class="contact-success-state text-center" style="padding: 60px 20px;">
      <div class="icon-box d-inline-flex align-items-center justify-content-center mb-4" style="background-color: #28a745; color: white; width: 80px; height: 80px; border-radius: 50%; font-size: 36px;">
        <i class="fa-solid fa-check"></i>
      </div>
      <h3 class="mb-3">${translations.successTitle || "Thank You"}</h3>
      <p style="color: #666;">${translations.successMessage || "Your message has been sent."}</p>
    </div>
  `;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    clearErrors();

    const formData = new FormData(form);
    const rawData = Object.fromEntries(formData.entries());

    const result = getContactSchema().safeParse(rawData);

    if (!result.success) {
      result.error.flatten().formErrors.forEach((msg) => {
        if (errorAlert) {
          errorAlert.style.display = "block";
          errorAlert.innerHTML += `<span>${msg}</span>`;
        }
      });
      Object.entries(result.error.flatten().fieldErrors).forEach(
        ([field, msgs]) => {
          if (msgs) setFieldError(field, msgs[0]);
        },
      );
      return;
    }

    // --- ON FLIGHT STATE ---
    if (fieldset) fieldset.disabled = true; // Prevents all interaction
    if (submitBtn) {
      submitBtn.innerText = translations.sending || "Sending...";
    }

    try {
      await api.post("/forms/contact", result.data);

      // --- SUCCESS STATE ---
      // Replace entire form content with success message
      container.innerHTML = renderSuccessState();
      container.scrollIntoView({ behavior: "smooth", block: "center" });

      // --- GA4 EVENT TRACKING ---
      // Safely check if gtag exists, then fire a 'generate_lead' event
      if (typeof (window as any).gtag === "function") {
        (window as any).gtag("event", "generate_lead", {
          form_type: "Contact Form",
        });
      }
    } catch (err: any) {
      // --- ERROR STATE ---
      if (fieldset) fieldset.disabled = false;
      if (submitBtn) submitBtn.innerText = originalBtnText;

      if (errorAlert) {
        errorAlert.style.display = "flex";
        errorAlert.innerHTML = `<span>${err.message || translations.errorGeneral || "Error"}</span>`;
      }
    }
  });
};
